import React from "react";
import Cell from "../Cell";
import { CirclePoint } from "../../style";
import ModuleBoardDialog from "../ModuleBoardDialog";
import SectionBoardDialog from "../SectionBoardDialog";
import { isMobileOnly } from "react-device-detect";

const BoardCell = ({
  type,
  rowId,
  tempId,
  tableManager,
  propertyList = [],
  errorMessage,
  dialogProps,
  sectionId,
  isFiller = false,
  boardIdentifiers = ["shutter_material", "carcass_material"],
  onContextMenu,
  pasteOverrides,
  viewMode,
  reviewColumnColorMap,
  onValueChange,
  setCurrentTab,
}) => {
  const renderBoardProperties = () => {
    if (tempId || !Array.isArray(propertyList)) return null;

    const shown = new Set();
    const boardProperties = propertyList.filter((property) =>
      boardIdentifiers.includes(property.identifier)
    );

    return boardProperties
      .filter((property) => {
        if (!property.is_overridden_v2 && type === "module") return false;

        const selectedOption = property.options.find((opt) => opt.selected);

        if (!selectedOption || shown.has(selectedOption.name)) return false;

        shown.add(selectedOption.name);

        return true;
      })
      .map((property, index, array) => {
        let selectedOption;

        if (pasteOverrides) {
          const overrideValues = [
            pasteOverrides.shutter_material,
            pasteOverrides.carcass_material,
          ].filter(Boolean);

          if (overrideValues.length > 0) {
            selectedOption = property.options.find((e) =>
              overrideValues.some(
                (val) => val === e.identifier || val === e.name
              )
            );
          }
        } else {
          selectedOption = property.options.find((opt) => opt.selected);
        }

        if (!selectedOption) return null;

        return (
          <div key={index} className="d-flex align-items-center gap-1">
            <div>{selectedOption?.name}</div>
            {index < array.length - 1 && <CirclePoint />}
          </div>
        );
      });
  };

  const getCellBackgroundColor = (column, value) => {
    if (!reviewColumnColorMap) return null;

    // Always use column-specific key to match the color map format
    const normalizedValue = value || "";
    const mapKey = `${column}__${normalizedValue}`;

    return reviewColumnColorMap[mapKey] || null;
  };

  return (
    <>
      {viewMode === "review" ? (
        <>
          {["shutter", "carcass"].map((e) => {
            const property = propertyList.find(
              (prop) => prop.identifier === `${e}_material`
            );
            const column = `review_${e}_material`;

            const selectedOption =
              property && property.options.find((opt) => opt.selected);

            const value =
              property && type === "module" ? selectedOption.name : "";

            onValueChange(
              type === "module" ? rowId : sectionId,
              column,
              (value || "").trim()
            );

            const backgroundColor = getCellBackgroundColor(column, value);

            return (
              <Cell
                key={column}
                rowId={rowId}
                sectionId={sectionId}
                rowType={type}
                column={column}
                className="flex-grow-0 flex-shrink-0"
                customStyles={{
                  width: isMobileOnly ? "15%" : "120px",
                  backgroundColor: backgroundColor || undefined,
                }}
                tableManager={tableManager}
              >
                <div className="fs-10px">{value}</div>
              </Cell>
            );
          })}
        </>
      ) : (
        <Cell
          rowType={type}
          rowId={rowId}
          column="board"
          status="focus"
          className=""
          tableManager={tableManager}
          isTemp={tempId}
          errorMessage={errorMessage}
          isFillerRow={isFiller}
          sectionId={sectionId}
          customStyles={{ width: isMobileOnly ? "100px" : "105px" }}
          onContextMenu={onContextMenu}
        >
          <div className="d-flex align-items-center flex-wrap gap-2">
            {renderBoardProperties()}
          </div>

          {tableManager.isActive(type, rowId, "board") &&
            (type === "module" ? (
              <ModuleBoardDialog {...dialogProps} setCurrentTab={setCurrentTab} />
            ) : (
              <SectionBoardDialog {...dialogProps} setCurrentTab={setCurrentTab} />
            ))}
        </Cell>
      )}
    </>
  );
};

export default BoardCell;
